import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { ComponentsModule, DirectiveModule, FinFormsModule, PipesModule } from '@fcom/common';
import { UiTranslateModule } from '@fcom/ui-translate';
import { UiComponentsModule } from '@fcom/ui-components';
import { CommonBookingAncillariesModule, CommonBookingComponentsModule } from '@fcom/common-booking';
import { RedirectServiceModule } from '@fcom/common-booking/modules/redirect-service';
import { AncillarySubviewModule } from '@fcom/common-booking/modules/ancillaries/components/ancillary-subview/ancillary-subview.module';
import { SubViewModule } from '@fcom/common-booking/components/subview/subview.module';
import { GtmModule } from '@fcom/common/gtm';
import { CmsModule } from '@fcom/cms/components';
import { QualtricsModule } from '@fcom/common/qualtrics/qualtrics.module';

import { ManageBookingCommonModule } from '../common/booking-common.module';
import { ManageBookingViewPassengersModule } from '../view-passengers/view-passengers.module';
import { CheckInBoardingPassRouteComponent } from './routes/check-in-boarding-pass-route.component';
import { CheckInExitRowSeatsComponent } from './components/check-in-exit-row-seats.component';
import { CheckInFunnelRoutingComponent } from './routes/check-in-funnel-routing.component';
import { CheckInPassengerDetailsComponent } from './components/check-in-passenger-details.component';
import { CheckInPassengerInfoComponent } from './components/check-in-passenger-info.component';
import { CheckInPassengerInfoBoxComponent } from './components/check-in-passenger-info-box.component';
import { CheckInSeatmapComponent } from './components/check-in-seatmap.component';
import { CheckInKnowYourTripComponent } from './components/check-in-know-your-trip.component';
import { CheckInRestrictedItemsComponent } from './components/check-in-restricted-items.component';
import { CheckInConfirmationRouteComponent } from './routes/check-in-confirmation-route.component';
import { CheckInSubheaderComponent } from './components/check-in-subheader.component';
import { CheckInApisRouteComponent } from './routes/check-in-apis-route.component';
import { ManageBookingTravelPreparationsModule } from '../travel-preparations/travel-preparations.module';
import { CheckInPassengersRouteComponent } from './routes/check-in-passengers-route.component';
import { CheckInSeatmapRouteComponent } from './routes/check-in-seatmap-route.component';
import { CheckInKnowYourTripRouteComponent } from './routes/check-in-know-your-trip-route.component';
import { CheckInRulesRouteComponent } from './routes/check-in-rules-route.component';
import { ApisPaxComponent } from '../travel-preparations/components/apis-pax/apis-pax.component';
import { CheckInBoardingPassStatusComponent } from './components/boarding-pass-status/check-in-boarding-pass-status.component';
import { CarTrawlerWidgetModule } from '../common/components/cartrawler-widget/cartrawler-widget.module';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    DirectiveModule,
    PipesModule,
    UiTranslateModule,
    UiComponentsModule,
    ManageBookingCommonModule,
    CommonBookingComponentsModule,
    RedirectServiceModule,
    ManageBookingViewPassengersModule,
    CommonBookingAncillariesModule,
    AncillarySubviewModule,
    SubViewModule,
    RouterModule,
    FinFormsModule,
    GtmModule,
    ManageBookingTravelPreparationsModule,
    CmsModule,
    CarTrawlerWidgetModule,
    QualtricsModule,
  ],
  declarations: [
    CheckInBoardingPassRouteComponent,
    CheckInExitRowSeatsComponent,
    CheckInFunnelRoutingComponent,
    CheckInPassengerDetailsComponent,
    CheckInPassengerInfoComponent,
    CheckInPassengerInfoBoxComponent,
    CheckInSeatmapComponent,
    CheckInKnowYourTripComponent,
    CheckInRestrictedItemsComponent,
    CheckInConfirmationRouteComponent,
    CheckInSubheaderComponent,
    CheckInPassengersRouteComponent,
    CheckInSeatmapRouteComponent,
    CheckInKnowYourTripRouteComponent,
    CheckInRulesRouteComponent,
    CheckInApisRouteComponent,
    ApisPaxComponent,
    CheckInBoardingPassStatusComponent,
  ],
  exports: [RouterModule],
})
export class CheckInModule {}
